export default {
  SET_CASHBOOK (state, cashBookTemporary) {
    state.cashBookTemporary = cashBookTemporary
  },
  REMOVE_RECORD (state, itemId) {
    const cashBookTemporaryIndex = state.cashBookTemporary.findIndex((u) => u.id === itemId)
    state.cashBookTemporary.splice(cashBookTemporaryIndex, 1)
  }
}
